
import {
    FETCH_LEARNING_HUB_DETAILS_REQUEST,
    FETCH_LEARNING_HUB_DETAILS_SUCCESS,
    FETCH_LEARNING_HUB_DETAILS_FAILURE,
} from '../../../Constants/actionTypes';

import { API_LEARNING_HUB_MICRO_DETAILS } from '../../../Constants/apiUrls';

// Helper function to handle errors
const handleErrors = async (response) => {
    if (!response.ok) {
        const errorText = await response.text();
        try {
            const errorJson = JSON.parse(errorText);
            return errorJson.error || 'Unknown Error'; // Return the error message
        } catch (e) {
            return errorText || 'Unknown Error'; // Return the error text if JSON parsing fails
        }
    }
    return null; // No error
};


export const fetchLearningHubDetailsRequest = () => ({
    type: FETCH_LEARNING_HUB_DETAILS_REQUEST,
});

export const fetchLearningHubDetailsSuccess = (data) => ({
    type: FETCH_LEARNING_HUB_DETAILS_SUCCESS,
    payload: data,
});

export const fetchLearningHubDetailsFailure = (error) => ({
    type: FETCH_LEARNING_HUB_DETAILS_FAILURE,
    payload: error,
});

// Thunk action creator
export const fetchLearningHubDetails = (id) => {
    return async (dispatch, getState) => {
        dispatch(fetchLearningHubDetailsRequest());

        // Retrieve access token from the state
        const state = getState();
        const accessToken = state.auth.accessToken; 

        try {
            const response = await fetch(API_LEARNING_HUB_MICRO_DETAILS(id), {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${accessToken}`, 
                },
            });
            const errorMessage = await handleErrors(response);
            if (errorMessage) {
                throw new Error(errorMessage); 
            }
            const data = await response.json();
            dispatch(fetchLearningHubDetailsSuccess(data));
        } catch (error) {
            let errorMessage;
            if (error.message === 'Failed to fetch' || error.message.includes('NetworkError')) {
                errorMessage = 'Server is currently down. Please try again later.';
            } else {
                errorMessage = error.message;
            }
            dispatch(fetchLearningHubDetailsFailure(errorMessage));
        }
    };
};


